import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

export const getPageTitle = (
    eventCodeInfo: EventDetailInfo,
    changeRequest: ChangeRequest,
): string => {
    if (eventCodeInfo) {
        return `${eventCodeInfo.code} - Event Update Form`;
    }

    return changeRequest && changeRequest.id
        ? `${changeRequest.event?.code} - Event Creation Form`
        : 'Event Creation Form';
};
